// SecondaryIntro.jsx
import React from "react";
import styles from "./secondary_intro.module.css";

const SecIntroBox = () => {
  return (
    <>
      <div className={styles.overlaysec}></div>
      <div className={styles.container_sec_intro}>
        <div className={styles.sec_layout}>
          <div className={styles.sec_shapes_column}>
            <div className={styles.sec_diamond_1}></div>
            <div className={styles.sec_diamond_2}></div>
            <div className={styles.sec_diamond_3}></div>
            <div className={styles.sec_diamond_4}></div>
          </div>
          <div className={styles.sec_content_box}>
            <div className={styles.sec_story}>
            <h1>Our Story</h1>
            <p>
              Mental health should never be a privilege, it's a necessity. Yet,
              so many struggle in silence due to stigma, fear of judgment, or
              the challenge of finding the right support. At Mento, we’re
              changing that.
            </p>
            <p>
              We created Mento to make mental wellness support accessible, safe,
              and stigma-free. Whether you're dealing with stress, anxiety, or
              simply seeking emotional support, you deserve guidance from
              certified counselors who understand and respect your journey
              without judgment.
            </p>

            <p>
              Our professional counselors offer virtual mental health
              counseling, ensuring help is always within reach. No long wait
              times, no fear of being misunderstood, just self-care made simple,
              affordable, and effective. Because at Mento, your well-being comes
              first
            </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecIntroBox;
